// === AANSPRAKELIJKHEID (AVP) — static product config ===
// Carrier/product identity for the rhion AVP2025 product (maatschappij R515). Pulled out of the
// screen so the payload helpers (calc.ts) and the request wrapper share one source.

export const AVP_PRODUCT = {
  carrierCode: 'R515',
  productName: 'rhion AVP2025',
} as const;

// GSS (gezinssamenstelling) code -> i18n key for PP_CONTROM: ONE map for every product.
export { GSS_CODE_TO_I18N_KEY } from '../../../utils/familyComposition';
